/* eslint-disable max-len */
import { Component, Inject, OnInit } from '@angular/core';
import { CalibrationAnnualPlan, CalibrationAnnualPlanFilter, CalibrationAnnualPlanGroup } from '../../../../model/calibration';
import { CalibrationAnnualPlanService } from '../../../../services/calibration-annual-plan.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { forkJoin, Observable, Subject, takeUntil } from 'rxjs';
import { SnackBarService } from '../../../../services/snackBar.service';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../../shared/confirmation-dialog/confirmation-dialog.component';
import { NumberUtils } from '../../../../utils/numberUtils';
import { CustomDatepickerHeaderComponent } from '../../../shared/datepicker-custom-header/datepicker-custom-header.component';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DateUtils } from '../../../../utils/dateUtils';
import * as _ from 'lodash';
import { DateTime } from 'luxon';
import { ViewPdfService } from '../../../../services/view-pdf.service';
import { InternalEquipmentFilterPerformance } from '../../../../model/internalEquipment';
import { StringUtils } from '../../../../utils/stringUtils';
import { SignatureEditSignersComponent } from '../../../signature/signature-edit-signers/signature-edit-signers.component';
import { DocumentListEnum } from '../../../../utils/documentListUtils';
import { User } from '../../../../model/user';
import { UserService } from '../../../../services/user.service';
import { ReasonDialogComponent } from '../../../shared/reason-dialog/reason-dialog.component';
import { ActionConfirmPasswordComponent } from '../../../shared/action-confirm-password/action-confirm-password.component';
import { CalibrationPlanEditGenerateReportDialogComponent } from '../calibration-plan-edit-generate-report-dialog/calibration-plan-edit-generate-report-dialog.component';
import { SignatureDocumentUsers } from '../../../../model/signatureDocumentUsers';
import { ConfirmationDialogSignatureComponent } from '../../../signature/confirmation-dialog-signature/confirmation-dialog-signature.component';
import { SignatureDocumentsService } from '../../../../services/signatureDocuments.service';
import { saveAs } from 'file-saver';
import { ActivatedRoute } from '@angular/router';
import { Constants } from '../../../../utils/constants';
import { ArrayUtils } from '../../../../utils/arrayUtils';

export interface DialogDataCalibrationPlan {
  filter: InternalEquipmentFilterPerformance,
  idCalibrationPlan: number;
}

@Component({
  selector: 'app-calibration-plan-edit-generate-dialog',
  templateUrl: './calibration-plan-edit-generate-dialog.component.html',
  styleUrls: ['./calibration-plan-edit-generate-dialog.component.scss'],
  standalone: false
})
export class CalibrationPlanEditGenerateDialogComponent implements OnInit {

  calibrationAnnualPlan: CalibrationAnnualPlan;
  annualPlanDatasource: CalibrationAnnualPlanGroup[];
  annualPlanCurrent: CalibrationAnnualPlanGroup[];
  mapCalibrationsAccordion: Map<number, boolean> = new Map();
  mapCalibrationsHistoricalAccordion: Map<number, boolean> = new Map();
  selectionToggle: string = '1';
  currentUser: User;
  hasFilterDateStart: boolean = false;
  hasFilterDateEnd: boolean = false;
  idPlanCalibration: number;
  customDatepickerHeader = CustomDatepickerHeaderComponent;
  private destroy$ = new Subject<void>();

  constructor(private calibrationAnnualPlanService: CalibrationAnnualPlanService,
    private snackBarService: SnackBarService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private spinnerService: SpinnerService,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<CalibrationPlanEditGenerateDialogComponent>,
    private viewPdfService: ViewPdfService,
    private signatureDocumentService: SignatureDocumentsService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataCalibrationPlan
  ) {
    this.currentUser = this.userService.currentProfile;

     this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
        const id = params[Constants.FIELD_ID_CALIBRATION_PLAN] as number;
  
        if (id != null) {
          this.idPlanCalibration = id;
        }
      });
  }

  ngOnInit(): void {
    this.calibrationAnnualPlan = new CalibrationAnnualPlan();

    if (this.data.filter) {
      let message = this.translate.instant('calibration-plan-annual.dialog.filter.selected.label') as string;
      message += '<br/>'
      this.calibrationAnnualPlan.filters = [];
      let eqFilter = new CalibrationAnnualPlanFilter();

      if (StringUtils.isNotEmpty(this.data?.filter?.name)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.name.label') as string;
        eqFilter.name = this.data?.filter?.name;
      }
      if (ArrayUtils.isNotEmpty(this.data?.filter?.idStatus)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.status.label') as string;
        eqFilter.idStatus = this.data?.filter?.idStatus;
      }
      if (StringUtils.isNotEmpty(this.data?.filter?.serialNum)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.serialNum.label') as string;
        eqFilter.serialNumber = this.data?.filter?.serialNum;
      }
      if (StringUtils.isNotEmpty(this.data?.filter?.group)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.group.label') as string;
        eqFilter.group = this.data?.filter?.group;
      }
      if (StringUtils.isNotEmpty(this.data?.filter?.type)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.type.label') as string;
        eqFilter.type = this.data?.filter?.type;
      }
      if (StringUtils.isNotEmpty(this.data?.filter?.maker)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.maker.label') as string;
        eqFilter.maker = this.data?.filter?.maker;
      }
      if (StringUtils.isNotEmpty(this.data?.filter?.model)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.model.label') as string;
        eqFilter.model = this.data?.filter?.model;
      }
      if (this.data?.filter?.expirationDateStart) {
        this.hasFilterDateStart = true;
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.nextIntervetionStart.label') as string;
        eqFilter.realizationDateStart = this.data?.filter?.expirationDateStart;
      }
      if (this.data?.filter?.expirationDateEnd) {
        this.hasFilterDateEnd = true;
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.nextIntervetionEnd.label') as string;
        eqFilter.realizationDateEnd = this.data?.filter?.expirationDateEnd;
      }
      if (StringUtils.isNotEmpty(this.data?.filter?.certificateNum)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.certificateNum.label') as string;
        eqFilter.certificateNumber = this.data?.filter?.certificateNum;
      }
      if (ArrayUtils.isNotEmpty(this.data?.filter?.idsVariable)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.variable.label') as string;
        eqFilter.idsVariable = this.data?.filter?.idsVariable;
      }
      if (ArrayUtils.isNotEmpty(this.data?.filter?.idsApp)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.appType.label') as string;
        eqFilter.idsApp = this.data?.filter?.idsApp;
      }
      if (StringUtils.isNotEmpty(this.data?.filter?.supplier)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.supplier.label') as string;
        eqFilter.supplier = this.data?.filter?.supplier;
      }
      if (StringUtils.isNotEmpty(this.data?.filter?.equipmentRange)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.equipmentRange.label') as string;
        eqFilter.equipmentRange = this.data?.filter?.equipmentRange;
      }
      if (StringUtils.isNotEmpty(this.data?.filter?.useRange)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.useRange.label') as string;
        eqFilter.useRange = this.data?.filter?.useRange;
      }
      if (StringUtils.isNotEmpty(this.data?.filter?.resolution)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.resolution.label') as string;
        eqFilter.resolution = this.data?.filter?.resolution;
      }
      if (StringUtils.isNotEmpty(this.data?.filter?.tolerance)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.tolerance.label') as string;
        eqFilter.tolerance = this.data?.filter?.tolerance;
      }
      if (StringUtils.isNotEmpty(this.data?.filter?.frequency)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.calibrationFrequency.label') as string;
        eqFilter.frequency = this.data?.filter?.frequency;
      }
     
      if (this.data?.filter?.idFolder) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.folder.label') as string;
        eqFilter.idsFolder = [];
        eqFilter.idsFolder.push(this.data?.filter?.idFolder);
      }
      if (this.data?.filter?.idResposible) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.resposible.label') as string;
        eqFilter.idResposible = this.data?.filter?.idResposible;
      }
      if (this.data?.filter?.idsEquipmentType) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.equipmentType.label') as string;
        eqFilter.idsEquipmentType = this.data?.filter?.idsEquipmentType;
      }
      if (this.data?.filter?.idsAction) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentList.filter.action.label') as string;
        eqFilter.idsAction = this.data?.filter?.idsAction;
      }
      if (StringUtils.isNotEmpty(this.data?.filter?.responsibleEquipment)) {
        message += '<br/>'
        message += '- ' + this.translate.instant('internalEquipmentEdit.general.resposible.equipment.label') as string;
        eqFilter.equipmentResponsible = this.data?.filter?.responsibleEquipment;
      }

      this.calibrationAnnualPlan.filters.push(eqFilter);

      if (eqFilter.realizationDateStart) {
        this.selectionToggle = '2';
        this.calibrationAnnualPlan.dateInit = eqFilter.realizationDateStart;
      }

      if (eqFilter.realizationDateEnd) {
        this.calibrationAnnualPlan.dateEnd = eqFilter.realizationDateEnd;
      }

      this.spinnerService.show();
      forkJoin({
        current: this.calibrationAnnualPlanService.findAllCurrent(),
        all: this.calibrationAnnualPlanService.findAll()
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ({ current, all }) => {
          this.annualPlanCurrent = current;
          this.annualPlanDatasource = all;
           this.spinnerService.hide();
          const dialogRefConfirm = this.dialog.open(ConfirmationDialogComponent, {
          data: {
              message: message,
              messageOk: this.translate.instant('button.accept') as string,
              canOk: true,
              canCancel: true,
              html: true
            }
          });

          dialogRefConfirm.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: boolean) => {
            if (!result) {
              this.calibrationAnnualPlan.filters = [];
              this.selectionToggle = '1';
              this.calibrationAnnualPlan.dateInit = null;
              this.calibrationAnnualPlan.dateEnd = null;
              this.data.filter = null;
              this.hasFilterDateStart = false;
              this.hasFilterDateEnd = false;
            }
          });
        },
        error: (err) => {
          console.error(err);
          this.spinnerService.hide();
        }
      });
    } else {
      this.findAllByGroup();
    }
  }

  findAllByGroup(): void {
    this.spinnerService.show();

    forkJoin({
      current: this.calibrationAnnualPlanService.findAllCurrent(),
      all: this.calibrationAnnualPlanService.findAll()
    })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: ({ current, all }) => {
        this.annualPlanCurrent = current;
        this.annualPlanDatasource = all;
        this.spinnerService.hide();
      },
      error: (err) => {
        console.error(err);
        this.spinnerService.hide();
      }
    });
  }

  prepareSave(): void {
    if (this.selectionToggle === '1') {
      /*this.calibrationAnnualPlan.dateEnd = DateUtils.strToDate(this.calibrationAnnualPlan.year + '-12-31');
      this.calibrationAnnualPlan.dateInit = DateUtils.strToDate(this.calibrationAnnualPlan.year + '-01-01');*/
    } else if (this.selectionToggle === '2') {
      this.calibrationAnnualPlan.dateEnd = DateUtils.anyToDate(this.calibrationAnnualPlan.dateEnd);
      this.calibrationAnnualPlan.dateInit = DateUtils.anyToDate(this.calibrationAnnualPlan.dateInit)
    }

    const errs = this.getErrorSave();
    if (errs.length === 0) {
      this.spinnerService.show();
      this.calibrationAnnualPlanService.existsPlanCalibrationCode(this.calibrationAnnualPlan.code).pipe(takeUntil(this.destroy$)).subscribe((exists) => {
        this.spinnerService.hide();
        if (!exists) {
          this.save();
        } else {
          this.spinnerService.hide();
          this.snackBarService.sendError(this.translate.instant('calibration-plan-annual.form.code.exists'));
        }
      });
    } else {
      this.snackBarService.sendError(errs.join('\n'));
    }
  }

  save(): void {
    this.spinnerService.show();
    this.calibrationAnnualPlanService.save(this.calibrationAnnualPlan).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.spinnerService.hide();
      this.clearFilter();
      this.findAllByGroup();
    }, error => {
      console.error(error);
      this.spinnerService.hide();
    });
  }

  clearFilter() {
    this.calibrationAnnualPlan = new CalibrationAnnualPlan();
    this.calibrationAnnualPlan.filters = [];
    this.selectionToggle = '1';
    this.calibrationAnnualPlan.dateInit = null;
    this.calibrationAnnualPlan.dateEnd = null;
    this.data.filter = null;
    this.hasFilterDateStart = false;
    this.hasFilterDateEnd = false;
  }

  getErrorSave(): string[] {
    let error = [];

    this.annualPlanDatasource?.forEach(e => {
      e.dateInit = DateUtils.anyToDate(e.dateInit);
      e.dateEnd = DateUtils.anyToDate(e.dateEnd);
    });

    if (!this.calibrationAnnualPlan.code) {
      error.push(this.translate.instant('calibration-plan-annual.form.code.error') as string);
    }

    /*if (!this.calibrationAnnualPlan.title) {
      error.push(this.translate.instant('calibration-plan-annual.form.title.error') as string);
    }*/

    if (this.selectionToggle === '1') {
      if (!this.calibrationAnnualPlan.year) {
        error.push(this.translate.instant('calibration-plan-annual.form.year.error') as string);
      } else {
        if (!NumberUtils.isYear(this.calibrationAnnualPlan.year.toString())) {
          this.snackBarService.sendError(this.translate.instant('calibration-plan-annual.form.year.type.error') as string);
        } else {
          this.calibrationAnnualPlan.year = Number(this.calibrationAnnualPlan.year);
        }
        /* const dataPlan = this.annualPlanDatasource?.filter(e => {
           e.calibrationAnnualPlans.forEach(cp => {
             return DateUtils.isDateBetweenEq(this.calibrationAnnualPlan.dateInit, e.dateInit, e.dateEnd) || DateUtils.isDateBetweenEq(this.calibrationAnnualPlan.dateEnd, e.dateInit, e.dateEnd)
           })
         });
         if (!dataPlan || dataPlan?.length === 0) {
           this.snackBarService.sendError(this.translate.instant('calibration-plan-annual.dialog.date.exists.error', { dateInit: this.fixDate.transform(this.calibrationAnnualPlan.dateInit), dateEnd: this.fixDate.transform(this.calibrationAnnualPlan.dateEnd) }) as string);
         }*/
      }
    } else {
      if (!this.calibrationAnnualPlan.dateInit || !this.calibrationAnnualPlan.dateEnd) {
        error.push(this.translate.instant('calibration-plan-annual.form.date.error') as string);
      } else {
        /*const dataPlan = this.annualPlanDatasource?.filter(e => DateUtils.isDateBetweenEq(this.calibrationAnnualPlan.dateInit, e.dateInit, e.dateEnd) || DateUtils.isDateBetweenEq(this.calibrationAnnualPlan.dateEnd, e.dateInit, e.dateEnd));
        if (!dataPlan || dataPlan?.length === 0) {
          this.snackBarService.sendError(this.translate.instant('calibration-plan-annual.dialog.date.exists.error', { dateInit: this.fixDate.transform(this.calibrationAnnualPlan.dateInit), dateEnd: this.fixDate.transform(this.calibrationAnnualPlan.dateEnd) }) as string);
        }*/

      }
    }
    return error;
  }

  isDefinitiveForVersion(cal: CalibrationAnnualPlan[]): boolean {
    const cals = cal.filter(e => !e.definitive || e.active);

    if (cals && cals?.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  newVersion(id: number): void {
    const message = this.translate.instant('calibration-plan-annual.dialog.year.exists.confirm') as string;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
      if (response) {
        this.requestReason((reason) => {
          if (reason) {
            this.requestSign((token) => {
              if (token) {
                this.spinnerService.show();

                this.calibrationAnnualPlanService.saveVersion(id, reason).pipe(takeUntil(this.destroy$)).subscribe((res) => {
                  this.spinnerService.hide();
                  this.findAllByGroup();
                }, error => {
                  console.error(error);
                  this.spinnerService.hide();
                });
              }
            });
          }
        });
      } else {
        this.calibrationAnnualPlan = new CalibrationAnnualPlan();
      }
    });
  }

  setCalibrationOpened(index: number, state: boolean): void {
    this.mapCalibrationsAccordion.set(index, state);
  }

  isCalibrationOpened(index: number): boolean {
    return this.mapCalibrationsAccordion.get(index);
  }

  signPlanAnnual(planAnnual: CalibrationAnnualPlan): void {
    this.spinnerService.show();

    this.calibrationAnnualPlanService.signPlan(planAnnual).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) {
        this.calibrationAnnualPlanService.generateCalibrationPlanById(planAnnual.id).pipe(takeUntil(this.destroy$)).subscribe((doc: Blob) => {
          this.viewPdfService.setPdfBytes(res, `${this.translate.instant('calibration-plan-annual-current.document.title')}-${planAnnual.code}.pdf`);
          //saveAs(doc,);
          this.spinnerService.hide();
          this.findAllByGroup();
        }, error => {
          console.error(error);
          this.spinnerService.hide();
        });
      }
    }, error => {
      console.error(error);
      this.spinnerService.hide();
    });
  }

  preprateGenerate(planAnnual: CalibrationAnnualPlan): void {
    if (!planAnnual.definitive) {
      const message = this.translate.instant('calibration-plan-annual.dialog.year.definitive.confirm') as string;

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });
      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response) {
          //this.signPlanAnnual(planAnnual);
          const dialogRef = this.dialog.open(SignatureEditSignersComponent, {
            minWidth: '80%',
            maxHeight: '95vh',
            data: {
              idDocument: planAnnual.id,
              documentType: DocumentListEnum.ANNUAL_CALIBRATION,
              nDocument: planAnnual.code,
              idClient: null,
              currentVersion: planAnnual.currentVersion
            }
          });

          dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
            if (result != null) {
              //this.existsSignerUsernamePending();
              this.snackBarService.sendSuccess(this.translate.instant('signers.dialog.ok'))
              this.findAllByGroup();
            }
          });
        } else {
          this.downloadCertificateAnnualPlan(planAnnual);
        }
      });
    } else {
      this.downloadCertificateAnnualPlan(planAnnual);
    }
  }

  openGenerateDialog(planAnnual: CalibrationAnnualPlan) {
    const dialogRef = this.dialog.open(CalibrationPlanEditGenerateReportDialogComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        calibrationPlan: planAnnual,
        isSignature: planAnnual.idStatus === 3 || planAnnual.idStatus === 2,
        hasCalibration: true,
        hasVerification: true
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: CalibrationAnnualPlan) => {
      if (result) {
        if (result.type === 1) {
          this.spinnerService.show();
          if (planAnnual.signatureDocument != null) {
            this.calibrationAnnualPlanService.generateCalibrationPlanById(planAnnual.id).pipe(takeUntil(this.destroy$)).subscribe((res: Blob) => {
              this.viewPdfService.setPdfBytes(res, `${this.translate.instant('calibration-plan-annual-current.document.title')}-${planAnnual.code}.pdf`);
              this.spinnerService.hide();
            }, error => {
              console.error(error);
              this.spinnerService.hide();
            });
          } else {
            this.spinnerService.show();
             this.calibrationAnnualPlanService.save(result).pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.calibrationAnnualPlanService.generateCalibrationPlanById(planAnnual.id).pipe(takeUntil(this.destroy$)).subscribe((res: Blob) => {
                this.viewPdfService.setPdfBytes(res, `${this.translate.instant('calibration-plan-annual-current.document.title')}-${planAnnual.code}.pdf`);
                this.spinnerService.hide();
              }, error => {
                console.error(error);
                this.spinnerService.hide();
              });
            }, error => {
              console.error(error);
              this.spinnerService.hide();
            });
          }
        } else if (result.type === 2) {
          const dialogRef = this.dialog.open(SignatureEditSignersComponent, {
            minWidth: '80%',
            maxHeight: '95vh',
            data: {
              idDocument: result.id,
              documentType: DocumentListEnum.ANNUAL_CALIBRATION,
              nDocument: result.code,
              idClient: null,
              currentVersion: result.currentVersion,
              reportConfig: result.cols
            }
          });

          dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((document: any) => {
            if (document === 'delete') {
              result.idStatus = 1;
              this.spinnerService.show();
              this.calibrationAnnualPlanService.save(result).pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.spinnerService.hide();
                this.findAllByGroup(); 
              }, error => {
                console.error(error);
                this.spinnerService.hide();
              });
            } else if (document === 'save') {
              result.idStatus = 2;
              this.spinnerService.show();
              this.calibrationAnnualPlanService.save(result).pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.snackBarService.sendSuccess(this.translate.instant('signers.dialog.ok'))
                this.spinnerService.hide();
                this.findAllByGroup(); 
              }, error => {
                console.error(error);
                this.spinnerService.hide();
              });
            }
          });
        } else if (result.type === 3) {
          this.findAllByGroup();
        }
      } else {
        this.findAllByGroup(); 
      }
    });
  }

  downloadCertificateAnnualPlan(planAnnual: CalibrationAnnualPlan): void {
    if (planAnnual && planAnnual.id) {
      this.spinnerService.show();

      let call: Observable<any> = null;

      if (planAnnual.idAttachment) {
        call = this.calibrationAnnualPlanService.downloadCalibrationPlanByIdAttachment(planAnnual.idAttachment);
      } else {
        call = this.calibrationAnnualPlanService.generateCalibrationPlanById(planAnnual.id);
      }

      if (call == null) {
        this.spinnerService.hide();

        this.snackBarService.sendError(this.translate.instant('internalEquipmentEdit.form.downloadPdf.error') as string);

        return;
      }

      call.pipe(takeUntil(this.destroy$)).subscribe((res: Blob) => {
        this.viewPdfService.setPdfBytes(res, `${this.translate.instant('calibration-plan-annual-current.document.title')}-${planAnnual.code}.pdf`);
        this.spinnerService.hide();
      }, error => {
        console.error(error);
        this.spinnerService.hide();
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  saveDate(field: string, event: MatDatepickerInputEvent<Date>): void {
    let value: Date | string = event.value;
    if (value != null) {
      if (value instanceof Date) {
        value = DateTime.fromJSDate(value).toFormat('dd/MM/yyyy');
      }

      let date = DateTime.fromFormat(value + ' 12:00:00 +00:00', 'dd/MM/yyyy HH:mm:ss Z');

      while (date.year < 1970) {
        date = date.plus({ years: 100 });
      }

      this.calibrationAnnualPlan[field] = date?.toJSDate();
      if (field === 'dateInit') {
        this.calibrationAnnualPlan.dateEnd = _.cloneDeep(this.calibrationAnnualPlan[field]);
        this.calibrationAnnualPlan.dateEnd.setMonth(this.calibrationAnnualPlan.dateEnd.getMonth() + 12);
      }
    } else {
      this.calibrationAnnualPlan[field] = null;
    }
  }

  changeToggle(event: string) {
    if (event == "1") {
      this.calibrationAnnualPlan.dateInit = null;
      this.calibrationAnnualPlan.dateEnd = null;
    } else {
      this.calibrationAnnualPlan.year = null;
    }
  }

  showSignature(plan: CalibrationAnnualPlan): boolean {
    return plan.signatureDocument != null;
  }

  showSignaturePending(plan: CalibrationAnnualPlan): boolean {
    return plan.hasSignaturePending;
  }

  openDialogSigner(planAnnual: CalibrationAnnualPlan) {
    const dialogRef = this.dialog.open(SignatureEditSignersComponent, {
      minWidth: '80%',
      maxHeight: '95vh',
      data: {
        idDocument: planAnnual.id,
        documentType: DocumentListEnum.ANNUAL_CALIBRATION,
        nDocument: planAnnual.code,
        idClient: null,
        currentVersion: planAnnual.currentVersion
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        this.findAllByGroup();
        this.snackBarService.sendSuccess(this.translate.instant('signers.dialog.ok'))
      }
    });
  }

  deleteHistorial(planAnnual: CalibrationAnnualPlan) {
    if (planAnnual.idStatus === 1 || planAnnual.idStatus === 2) {
       const message = this.translate.instant('calibration-plan-annual.dialog.deleteProcess.confirm') as string;

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response) {
          this.spinnerService.show();
          this.calibrationAnnualPlanService.deleteById(planAnnual.id).pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.snackBarService.sendSuccess(this.translate.instant('calibration-plan-annual.dialog.save.ok') as string);
            this.spinnerService.hide();
            this.findAllByGroup();
          }, error => {
            this.spinnerService.hide();
            this.snackBarService.sendError(this.translate.instant('calibration-plan-annual.dialog.save.error') as string);
          });
        }
      });
    } else {
      const message = this.translate.instant('calibration-plan-annual.dialog.delete.confirm') as string;

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response) {
          this.requestReason((reason) => {
            if (reason) {
              this.requestSign((result) => {
                if (result) {
                  this.spinnerService.show();
                  this.calibrationAnnualPlanService.invalidate(planAnnual.id, reason).pipe(takeUntil(this.destroy$)).subscribe((res) => {
                    this.spinnerService.hide();
                    this.findAllByGroup();
                  }, error => {
                    this.spinnerService.hide();
                    this.snackBarService.sendError(this.translate.instant('calibration-plan-annual.dialog.save.error') as string);
                  });
                }
              });
            }
          });
        }
      });
    }
  }

  prepareToSign(plan: CalibrationAnnualPlan): void {
    const message = this.translate.instant('signers.sign.user.valid') as string;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
      if (response) {
        this.requestSign((token: string) => {
          this.saveSignatureByUser(token, plan);
        });
      }
    });
  }

  refuseDoc(planAnnualPlan: CalibrationAnnualPlan) {
    this.requestReason((reason) => {
      if (reason) {
        this.requestSign((token) => {
          if (token) {
            planAnnualPlan.idStatus = 1;
            this.spinnerService.show();
            this.calibrationAnnualPlanService.save(planAnnualPlan).pipe(takeUntil(this.destroy$)).subscribe((res) => {
              this.signatureDocumentService.refuseToSign(planAnnualPlan.signatureDocument.idSignature, planAnnualPlan.signatureDocument.id, reason).pipe(takeUntil(this.destroy$)).subscribe((result: SignatureDocumentUsers) => {
                  this.snackBarService.sendSuccess(this.translate.instant('signatureDocument.signature.refuse.ok'));
                  this.spinnerService.hide();
                  this.findAllByGroup();
              }, error => {
                this.spinnerService.hide();
              });
            });
          }
        });
      }
    });
  }

  saveSignatureByUser(token: string, plan: CalibrationAnnualPlan) {
    this.spinnerService.show();
    plan.signatureDocument.idStatus = 2;
    this.signatureDocumentService.saveDocumentUser(plan.signatureDocument, token).subscribe((result: SignatureDocumentUsers) => {
      if (result) {
        this.spinnerService.hide();

        this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.signature.complete.ok') as string);
        if (result.message) {
          const dialogRef = this.dialog.open(ConfirmationDialogSignatureComponent, {
            data: {
              canCancel: false,
              canOk: false,
              icon: true,
              html: true,
              messageOk: this.translate.instant('common.continue'),
              idSignature: plan.signatureDocument.idSignature
            }
          });

          dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
             this.findAllByGroup();
          });
        } else {
           this.findAllByGroup();
        }
      } else {
        this.spinnerService.hide();
        this.snackBarService.sendError(this.translate.instant('protocolEdit.signature.complete.error') as string);
      }
    }, error => {
      this.spinnerService.hide();
    });
  }

  canSign(planCalibration: CalibrationAnnualPlan): boolean {
    return planCalibration != null && planCalibration.signatureDocument != null && planCalibration.signatureDocument.active && !planCalibration.hasManual;
  }

  getStatus(planCalibration: CalibrationAnnualPlan): string {
    switch (planCalibration.idStatus) {
      case 1:
        return this.translate.instant('calibrationAnnual.process')
      case 2:
        return `${this.translate.instant('calibrationAnnual.pendingSign')}` + `${(planCalibration.hasManual ? (' manual') : '' )}`
      case 3:
        return `${this.translate.instant('calibrationAnnual.sign')}` + `${(planCalibration.hasManual ? (' manual') : '' )}`
      case 4:
        return this.translate.instant('calibrationAnnual.invalidate')     
      case 5:
        return this.translate.instant('calibrationAnnual.expired')  
      default:
        break;
    }
  }

  getPendingStatus(group: CalibrationAnnualPlanGroup): boolean {
    return group.calibrationAnnualPlans?.some(cp => cp.signatureDocument != null || (this.idPlanCalibration && cp.id === this.idPlanCalibration));
  }

  downloadExcel(planAnnual: CalibrationAnnualPlan): void {
    this.spinnerService.show();
    let call: Observable<any> = null;

    if (planAnnual.idExcel) {
      call = this.calibrationAnnualPlanService.downloadCalibrationPlanByIdAttachment(planAnnual.idExcel);
    } else {
      call = this.calibrationAnnualPlanService.generateExcelCalibrationPlanById(planAnnual.id);
    }

    if (call == null) {
      this.spinnerService.hide();

      this.snackBarService.sendError(this.translate.instant('internalEquipmentEdit.form.downloadPdf.error') as string);

      return;
    }

    call.pipe(takeUntil(this.destroy$)).subscribe((res: Blob) => {
      saveAs(res, `${planAnnual.code}.xlsx`);
      this.spinnerService.hide();
    }, error => {
      console.error(error);
      this.snackBarService.sendError(this.translate.instant('internalEquipmentEdit.form.downloadPdf.error') as string);
      this.spinnerService.hide();
    });
  }
  
  setCalibrationHistoricalOpened(index: number, state: boolean): void {
    this.mapCalibrationsHistoricalAccordion.set(index, state);
  }

  isCalibrationHistoricalOpened(index: number): boolean {
    return this.mapCalibrationsHistoricalAccordion.get(index);
  }
  private requestReason(callback: (reason: string) => void) {
    const dialogRef = this.dialog.open(ReasonDialogComponent, {
      minWidth: '40%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        callback(result);
      }
    });
  }

  private requestSign(callback: (token: string) => void) {
    this.spinnerService.hide();

    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        callback(result);
      }
    });
  }
}
